import { lazy, Suspense } from 'react'
import { cn } from '@/lib/utils'

// Проигрыватель Rive тяжёлый — грузим его только когда на экране есть `.riv`.
const RiveAnimation = lazy(() => import('./RiveAnimation'))

/** Маскот на карте: Rive-анимация (`.riv`) или обычная картинка / GIF. */
export const MascotMedia = ({ src, className }: { src: string; className?: string }) =>
  /\.riv(\?|$)/i.test(src) ? (
    <Suspense fallback={<div className={className} />}>
      <RiveAnimation src={src} className={cn('[&_canvas]:!size-full', className)} />
    </Suspense>
  ) : (
    <img src={src} alt="" className={className} />
  )
